import defaultApiBackend from './api.js';
import utils from './utils.js';
export default function (options) {
    var defaultOption = {
        container: options.element || document.getElementsByClassName('mfunsPlayer')[0],
        autoPlay: false,
        autoSwitch: false,
        smallWindow: true,
        draggable: true,
        blackBorder: false,
        theme: '#7b7ff7',
        loop: false,
        muted: false,
        hotkey: true,
        userIsLogged: false,
        widescreen: false,
        widescreenSwitch: false,
        preload: 'metadata',
        volume: 0.7,
        currentVideo: 0,
        apiBackend: defaultApiBackend,
        video: [],
        contextmenu: [],
        mutex: true,
        activity: [],
        callback: {},
        pluginOptions: {
            hls: {},
            flv: {},
            dash: {},
            webtorrent: {}
        },
        pickerColors: [
            '#FE0302',
            '#FFFF00',
            '#00CD00',
            '#00FF00',
            '#4E6EF2',
            '#89D5FF',
            '#7B7FF7',
            '#757575',
            '#FFFFFF',
            '#FB7229'
        ]
    };
    options = Object.assign(defaultOption, options);
    if (options.danmaku) {
        options.danmaku = Object.assign({
            api: '',
            margin: 5,
            opacity: 1,
            shields: [],
            limitArea: 4,
            fontScale: 1,
            speed: 1,
            editor: 1,
            sensitivity: 3,
            danmakuCatch: true,
            showHighEnergy: true,
            keepOutSubtitle: false,
            showDanmaku: true
        }, options.danmaku || {});
    }
    options.contextmenu = options.contextmenu.concat([
        {
            text: '作者信息',
            link: 'https://www.mfuns.xyz/author/7376'
        },
        {
            text: '参与开发者信息',
            link: 'https://www.mfuns.xyz/author/6068'
        },
        {
            text: '视频统计信息',
            click: function click(player) {
                player.infoPanel.toggle();
            }
        },
        {
            text: '视频色彩调节',
            click: function click(player) {
                player.videoColor.toggle();
            }
        },
        {
            text: '快捷键说明',
            click: function click(player) {
                player.hotkey.toggle();
            }
        },
        {
            text: 'mfunsPlayer v'.concat(MFUNSPLAYER_VERSION),
            link: 'https://github.com/Mfuns-cn/mfunsPlayer'
        }
    ]);
    return options;
};